import { render, staticRenderFns } from "./SignatureTemplate3.vue?vue&type=template&id=70135d99&"
import script from "./SignatureTemplate3.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports